<div class="c-modal" [class.c-modal__default-size]="!autoSize" [class.u-padding--none]="!hasPadding">
  <div *ngIf="showCloseBtn" class="c-modal__close">
    <ion-icon name="close-sharp" (click)="dismiss()"></ion-icon>
  </div>
  <ng-content></ng-content>
</div>
